<template>
    <div>
        <confirm ref="confirm"></confirm>        
        <list v-bind:refresh="this.refresh" v-bind:refreshSubList="this.refreshChild" table='pznscustomer' :label="$t('pzns')" v-on:childMessage="onMessageFromListReceived" v-on:sublistMessage="onMessageFromSubListReceived" initialSortBy="pzn" :initialSortDesc="false" :subListDefinition="subListDefinition"></list>
        <v-dialog v-bind:value="showFileDialog" v-bind:persistent="true" max-width="600">
            <v-card>
                <v-card-title>
                    {{$t("upload file")}}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon dense right color="primary" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span v-if="type=='PZN'">{{$t("import pzn")}}</span>
                        <span v-else>{{$t("import competitor")}}</span>
                    </v-tooltip>
                </v-card-title>
                <v-card-text>
                    <v-file-input show-size v-model=file :label="$t('select file')"/>
                    <v-select v-model="folder" :label="$t('type')" :items=getFolders()></v-select>
                    <v-checkbox v-model="overwrite" :label="$t('overwrite file')"></v-checkbox>
                    <v-select v-if="isAdmin()" v-model="customerId" :label="$t('customer')" :items=getCustomers() item-text="customername" item-value="id"></v-select>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=submitFile><v-icon dense left>mdi-cloud-upload-outline</v-icon>{{$t("upload")}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-cancel</v-icon>{{$t("cancel")}}</v-btn>
                </v-card-actions>
            </v-card>            
        </v-dialog>        
        <v-dialog v-bind:value="showDialog" v-bind:persistent="true" max-width="600">            
            <v-card>
                <v-card-title>
                    {{title}}
                </v-card-title>
                <v-card-text>
                    <div v-for="field in fields" v-bind:key="field.value">                        
                        <div v-if="field.value !== 'id' && field.value !== 'actions' && field.value !== 'manufacturer' && field.value !== 'details' && field.value !== 'parentID' && field.value !== 'brand'">
                            <v-select v-if="field.value == 'country'" v-model="field.model" v-bind:label="field.text" :items=getCountries() item-text="value" item-value="code"></v-select>
                            <v-switch v-else-if="field.value == 'prioproduct'" dense v-model="field.model" v-bind:label="field.text"></v-switch>
                            <v-switch v-else-if="field.value == 'launch'" dense v-model="field.model" v-bind:label="field.text"></v-switch>
                            <v-switch v-else-if="field.value == 'zalando'" dense v-model="field.model" v-bind:label="field.text"></v-switch>
                            <v-switch v-else-if="field.value == 'douglas'" dense v-model="field.model" v-bind:label="field.text"></v-switch>
                            <v-switch v-else-if="field.value == 'defektmonitor'" dense v-model="field.model" v-bind:label="field.text"></v-switch>
                            <v-text-field v-else-if="field.value != 'customername'" v-model="field.model" v-bind:label="field.text"/>
                            <v-select v-else v-model="field.model" v-bind:label="field.text" :items=getCustomers() item-text="customername" item-value="id"></v-select>
                        </div>
                    </div>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=save()><v-icon dense left>mdi-content-save-outline</v-icon>{{$t("save")}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-cancel</v-icon>{{$t("cancel")}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=uploadFile()><v-icon dense left>mdi-file-upload-outline</v-icon>{{$t("upload file")}}</v-btn>
                </v-card-actions>
            </v-card>            
        </v-dialog>        
    </div>
</template>

<script>

import List from "@/components/List"
import Api from "@/Api"
import { Utils } from "@/Utils"
import Confirm from "@/components/Confirm";

export default {
    components:
    {
        List, Confirm
    },

    data()
    {
        return {
            customerId: "",
            showDialog: "",
            showFileDialog: "",
            file: null,
            fields: [],
            refresh: 0,
            refreshChild: 0,
            title: "",
            text: "",
            pznID: -1,
            sublistTitle: "",            
            type: "PZN",
            folder: "Allgemein",
            overwrite: false,
            subListDefinition: [{label: this.$t("competitors"), table:"pznscompetitors", initialSortBy:"pzn", initialSortDesc:false}]
        };
    },

    props: [],

    mixins: [Utils],

    methods:
    {
        onMessageFromListReceived (message)
        {
            this.text = "";
            if (message.cmd === "searchExecuted")
            {
                this.pznID = -1;
            }
            else if (message.cmd === "recordSelected")
            {   
                this.pznID = message.item.id;
                this.sublistTitle = this.$t("competitors for product")+ " "+message.item.pzn;
            } 
            else if (message.cmd === "newRecord")
            {
                this.title = this.$t("new pzn");
                this.type = "PZN"
                this.fields = JSON.parse(JSON.stringify(message.header));
                this.fields.shift(); //remove ID

                for (let field of this.fields)
                {                    
                    field.model = "";
                }
                this.showDialog = true;
            }
            else if (message.cmd === "updRecord")
            {
                this.title = this.$t("update pzn");
                this.type = "PZN"
                this.fields = JSON.parse(JSON.stringify(message.header));

                for (let field of this.fields)
                {                                        
                    if (field.value === "customername")
                    {                        
                        const customerId = this.getCustomerId(message.item[field.value]);                        
                        if (customerId > 0)
                            field.model = customerId;
                        else
                            field.model = ""                        
                    }
                    else
                        field.model = message.item[field.value]
                }
                this.showDialog = true;
            }
            else if (message.cmd === "delRecord")
            {
                const id = message.item["id"];
                const self = this;
                Api.deleteRecord("pznscustomer", id).then(function(result)
                {
                    if (result.status === 200)
                    {
                        self.refresh += 1;
                    }
                    else
                        alert (self.$t("action not possible"));

                })
                .catch((e) =>
                {
                    alert (self.$t("action not possible"));
                });
            }
        },
        onMessageFromSubListReceived (message)
        {
            this.text = "";
            if (message.cmd === "newRecord")
            {
                this.title = this.$t("new competitor");
                this.type = "COMPETITOR";
                this.fields = JSON.parse(JSON.stringify(message.header));
                console.log(message.header)
                this.fields.shift(); //remove ID

                for (let field of this.fields)
                {                    
                    field.model = "";
                }
                this.showDialog = true;
            }
            else if (message.cmd === "updRecord")
            {
                this.title = this.$t("update competitor");
                this.type = "COMPETITOR";
                this.fields = JSON.parse(JSON.stringify(message.header));

                for (let field of this.fields)
                {                    
                    field.model = message.item[field.value]
                }
                this.showDialog = true;
            }
            else if (message.cmd === "delRecord")
            {
                const id = message.item["id"];
                const self = this;
                Api.deleteRecord("pznscompetitors", id).then(function(result)
                {
                    if (result.status === 200)
                    {
                        self.refreshChild += 1;
                    }
                    else
                        alert (self.$t("action not possible"));
                })
                .catch((e) =>
                {
                    alert (self.$t("action not possible"));
                });
            }
        },
        cancel ()
        {
            this.customerId = "";
            this.showFileDialog = "";
            this.showDialog = "";
            this.fields = [];
            this.text = "";
            this.file = null;
        },
        save ()
        {
            const self = this;
            this.text = "";
            for (let field of this.fields)
            {                
                if (field.text === "PZN")
                {
                    if (field.model.trim() == "")
                    {
                        this.text = this.$t("enter pzn");
                        return;
                    }
                    else
                        break;
                }
            }
            
            if (this.type == "COMPETITOR")
            {
                let parentFound = false;
                for (let field of this.fields)
                {                    
                    if (field.text === "parentID")
                    {
                        field.model = this.pznID;                    
                        parentFound = true;
                        break;
                    }
                }
                if (!parentFound)
                    this.fields.push({model:this.pznID, text:"parentID", value:"parentID"});
            }

            const table = (this.type === "COMPETITOR" ? "pznscompetitors" : "pznscustomer")

            Api.saveRecord(table, this.fields).then(function(result)
            {
                if (result.status === 200)
                {
                    self.showDialog = "";
                    if (table == "pznscompetitors")
                        self.refreshChild++;
                    else
                        self.refresh++;
                }
                else
                    self.text = self.$t("action not possible");

            })
            .catch((e) =>
            {
                if (e.response.status === 409)
                    self.text = self.$t("already exists");
                else
                    self.text = self.$t("action not possible");
            });
        },
        uploadFile ()
        {
            this.cancel();
            this.showFileDialog = true;
        },
        submitFile()
        {
            if (!this.file)
            {
                this.text = self.$t("select file");
                return;
            }
            const self = this;
            this.text = "";   
            
            const doctype = (this.type == "PZN" ? "PZNS" : "COMPETITORS")
            let formData = new FormData();
            formData.append('file', this.file);            
            formData.append('folder', this.folder);
            formData.append('overwrite', this.overwrite);
            formData.append('type', doctype);
            
            if (this.isAdmin())
                formData.append('customerId', this.customerId)

            Api.uploadFile(formData)
            .then(function(e)
            {
                if (e.data.result == "processed")
                {
                    self.$refs.confirm.open(self.$t("file processed"), {confirm:false}).then((confirm) =>
                    {
                        self.cancel();
                        if (doctype == "PZNS")
                            self.refresh++;
                        else
                            self.refreshChild++;      
                    });             
                }
                else if (e.data.result == "error")
                {
                    self.text = self.$t("processing not possible");
                    if (e.data.details)
                        self.text += " " + e.data.details;
                }
                else
                    self.cancel();                                                              
            })
            .catch(function(e)
            {
                if (e.response.status === 409)
                    self.text = self.$t("already exists");
                else
                    self.text = self.$t("action not possible");
            });
        },
    }
};
</script>